import { GenericError } from '@psyomics/ui-components';
import { Route, Routes } from 'react-router-dom';

import { ActivityDashboard } from '../features/activity-dashboard/activity-dashboard';

import { Home } from './home';
import { DirectLink } from './routes/direct-link';
import { Referrals } from './routes/referrals/referrals';
import { Report } from './routes/report/report';

const App = () => (
  <Routes>
    <Route Component={Home} path="/" />
    <Route Component={Report} path="/report/:referralId/:referralSessionId/*" />
    <Route Component={Report} path="/report/:referralId" />
    <Route Component={Referrals} path="/referrals" />
    <Route Component={ActivityDashboard} path="/activity-dashboard" />
    <Route Component={DirectLink} path="/direct-link/:action" />
    <Route element={<GenericError titleKey="common.errors.notFound" />} path="/*"></Route>
  </Routes>
);

export default App;
